module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_v_brown.bb289c02.png";